import { lazy, Suspense } from 'react';
import { EnvService } from '@hub/services/core/env-service';
import { useBooleanFeatureFlag } from '@monorepo/feature-flag/client';
import { FLAG } from '@monorepo/feature-flag/shared';
import { DashboardLoader } from './dashboard/components';

// Lazy load both dashboard versions
const AffiliationDashboardOld = lazy(
  () => import('./dashboard/affiliation-dashboard'),
);

const AffiliationDashboardNova = lazy(
  () => import('./dashboard-nova/affiliation-dashboard'),
);

const AffiliationDashboardWrapper = () => {
  const useNovaLayout = useBooleanFeatureFlag(FLAG.AFFILIATE_NOVA_LAYOUT, {
    env: EnvService.application,
  });

  const DashboardComponent = useNovaLayout
    ? AffiliationDashboardNova
    : AffiliationDashboardOld;

  return (
    <Suspense fallback={<DashboardLoader />}>
      <DashboardComponent />
    </Suspense>
  );
};

export default AffiliationDashboardWrapper;
